<div *ngIf="tripSheet">
  <app-verify-trip-sheet
    (updateTripSheet)="reloadTripSheet($event)"
    [tripSheet]="tripSheet"
  >
  </app-verify-trip-sheet>
</div>
